export const formatAlgos = (cell: any) => {
  cell
    .getElement()
    .classList.remove('bg-info', 'bg-warning', 'bg-danger', 'bg-secondary');
  const dataCell = cell.getData();
  const algos = dataCell.algorands / 1000000;
  const assets = dataCell.assetsCount;
  const neededAlgos = assets * 0.1;
  let className = '';
  // Algorand require to have 0.1 algos for each assets....
  if (neededAlgos > algos) {
    className = 'bg-danger';
  } else if (neededAlgos + 2 > algos) {
    className = 'bg-warning';
  } else {
    className = 'bg-success';
  }
  cell.getElement().classList.add(className);
  return algos;
};